"use client";

import { useEffect } from "react";
import { createPromotionTracker } from "./promotion-tracking";

/**
 * Fires view_promotion, select_promotion and carousel select_content events
 * for banners marked with data-promo-* attributes.
 */
export function PromotionTracker(props: Readonly<{ locationId: string }>) {
  useEffect(() => createPromotionTracker(props.locationId), [props.locationId]);

  return null;
}
